import {
  ExportOptions,
  ExportPayloadSection,
  SerializeExportProgress,
} from '../types';
import { resolveWorker } from './exportWorkerInstance';
import { runInWorker } from './runInWorker';
import { runFallback } from './runFallback';
import { triggerBlobDownload } from './triggerBlobDownload';

export const downloadExport = async (
  fileBaseName: string,
  sections: ExportPayloadSection[],
  options: ExportOptions,
  onProgress?: SerializeExportProgress,
  signal?: AbortSignal
): Promise<void> => {
  const worker = resolveWorker();
  const result = worker
    ? await runInWorker(worker, sections, options, onProgress, signal)
    : await runFallback(sections, options, onProgress, signal);

  if (signal?.aborted) {
    throw new DOMException('Export cancelled', 'AbortError');
  }

  triggerBlobDownload(fileBaseName, result);
};
